import React, { createContext, useContext } from 'react';
import {
  Network,
  PuzzleAccount,
  RecordWithPlaintext,
  useAccount,
} from '@puzzlehq/sdk';
import { useAleoBalance, useArcadeCoins } from '@puzzlehq/frontend-utils';
import { Balance } from '@puzzlehq/types';

type PuzzleGameContextType = {
  account: PuzzleAccount | undefined;
  network: Network | undefined;
  parcBalanceTotal: number | undefined;
  aleoBalance: Balance | undefined;
  aleoBalanceTotal: number | undefined;
  arcadeCoin: RecordWithPlaintext | undefined;
};

export const PuzzleGameContext = createContext<PuzzleGameContextType | null>(
  null
);

export const PuzzleGameProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { account } = useAccount();
  const { balance: parcBalance, arcadeCoin } = useArcadeCoins(1, false, false);
  const { totalBalance, creditsBalance } = useAleoBalance();

  const walletNetwork = account?.network;

  return (
    <PuzzleGameContext.Provider
      value={{
        account,
        network: walletNetwork,
        parcBalanceTotal: parcBalance,
        aleoBalance: creditsBalance as Balance | undefined,
        aleoBalanceTotal: totalBalance,
        arcadeCoin,
      }}
    >
      {children}
    </PuzzleGameContext.Provider>
  );
};

export const usePuzzleGameContext = () => {
  const ctx = useContext(PuzzleGameContext);

  return {
    account: ctx?.account,
    network: ctx?.network,
    parcBalance: ctx?.parcBalanceTotal,
    aleoBalance: ctx?.aleoBalance,
    aleoBalanceTotal: ctx?.aleoBalanceTotal,
    arcadeCoin: ctx?.arcadeCoin,
  };
};
